import { z } from "zod";

export interface CheckRequestDetail {
  id: number;
  idMovimientoBIND: string;
  montoSolicitado: number;
  saldoActual: number;
  fechaSolicitud: string;
  cuentaOrigen: string;
  sucursal: string;
  solicitante: string;
  estado: string;
  control: boolean;
  nroCheque: string;
  fechaVto: string;
  tipoSolicitud: string;
  idTipoSolicitud: number;
  tipoCuenta: string;
  mensajes: {
    texto: string;
    fechaHora: string;
    usuario: string;
    esUsted: boolean;
  }[];
}

export const checkRequestFilterSchema = z.object({
  request_date: z.any().optional(),
  account_owner: z.any().optional(),
  sucursal: z.any().optional(),
  request_amount: z.any().optional(),
  requester: z.any().optional(),
  account_number: z.any().optional(),
  estados: z.any().optional(),
  request_type: z.any().optional(),
});

export const checkRequestCreationSchema = z.object({
  account: z.any().optional(),
  account_type: z.any().optional(),
  sucursal: z.any().optional(),
  request_amount: z.any().optional(),
  request_detail: z.any().optional(),
  usuarioMobile: z.any().optional(),
  fechaVto: z.any().optional(),
  tipoSolicitud: z.any().optional(),
});

export interface CheckRequestEntity {
  id: number;
  fechaCreacion: string;
  idTipoSolicitud: number;
  tipoSolicitudDescripcion: string;
  idEstado: number;
  estadoDescripcion: string;
  titular: string;
  idSucursal: number;
  sucursalNombre: string;
  monto: number;
  usuarioCrea: string;
  control: boolean;
  estado: string;
}
